





import Vue from 'vue'
import Avatar from '@/components/Avatar/avatar.vue'
import Student from '@/models/Students/Student'

export default Vue.extend({
  name: 'PatientIndexColumn',
  props: {
    row: Object as () => Student,
  }
})
